import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { encodeBytes32String, decodeBytes32String, formatUnits } from "ethers";
import { useWalletConnection } from "../../utility/useWalletConnection";
import { useData } from "../../utility/useData";
import { useDispatch } from "react-redux";
import { getInfo, getIsClaimed } from "../../pages/Home/store";
import ConnectButton from "../connect-button/ConnectButton";
import UserTicketsPopup from "../popups/UserTickets";
import PageLoading from "../popups/PageLoading";
//css
import "./Stake.css";
//images
import Pin from "../../assets/img/pin.png";
import Close from "../../assets/img/closes.png";
import Countdown from "../countdown/Countdown";
import PrizeDetails from "../popups/PrizeDetails";
import ArrowDown from "../../assets/img/arrow-down.png";
import { formatSecondToDay } from "../../utility/Utils";

const Stake = ({ handleFlyToCity }) => {
  const poolImages = require.context("../../assets/pools/");
  const { search } = useLocation();
  const dispatch = useDispatch();

  const {
    isConnected,
    connectedWalletInfo,
    address,
    chainId,
    signerVars,
    unSignerVars,
    mockVRF,
    errorMessage,
    clearError,
    open,
    connect,
    disConnect,
  } = useWalletConnection();

  const {
    decimals,
    initialResultMsg,
    initialData,
    initialGetInfo,
    reRender,
    poolData,
    showPoolDetail,
    setReRender,
    updatePoolData,
    togglePoolData,
    openData,
    closeData,
    statusText,
    getToken,
  } = useData();

  const joinTicketCountRef = useRef();
  // const usedRefCodeRef = useRef();

  const [pageLoading, setPageLoading] = useState(false);
  const [pageLoadingMsg, setPageLoadingMsg] = useState(null);
  const [btnLoading, setBtnLoading] = useState(null);
  const [btnLoadingMsg, setBtnLoadingMsg] = useState(null);
  const [resultMsg, setResultMsg] = useState(initialResultMsg);
  const [contractGetInfo, setContractGetInfo] = useState(initialGetInfo);
  const [togglePrizeDetails, setTogglePrizeDetails] = useState(false);
  const [toggleUserTickets, setToggleUserTickets] = useState(false);
  const [totalLock, setTotalLock] = useState(null);
  const [tokenAmount, setTokenAmount] = useState("");
  const [totalPrize, setTotalPrize] = useState(null);
  const [isClaimed, setIsClaimed] = useState(null);
  const [userBalance, setUserBalance] = useState(null);
  const [lockedAmount, setLockedAmount] = useState();

  const getTotalLockAmount = async () => {
    const amount = formatUnits(
      await unSignerVars.contract.totalLockAmount(poolData.poolId, address),
      poolData.lockTokenDecimals
    );
    setTotalLock(amount);
  };

  const getTotalPrizeAmount = async () => {
    const amount = formatUnits(
      await unSignerVars.contract.totalPrizeAmount(poolData.poolId, address),
      poolData.prizeTokenDecimals
    );
    setTotalPrize(amount);
  };

  const changeTicketCount = (poolData) => {
    const ticketCount = joinTicketCountRef.current.value;
    if (ticketCount > 0 && ticketCount <= poolData.callbackMaxTicket) {
      joinTicketCountRef.current.value = ticketCount;
    } else {
      if (ticketCount < poolData.minTicketCount) {
        joinTicketCountRef.current.value = poolData.minTicketCount;
      }
      if (ticketCount >= poolData.callbackMaxTicket) {
        joinTicketCountRef.current.value = poolData.callbackMaxTicket;
      }
    }
    setTokenAmount(
      String(
        joinTicketCountRef.current.value *
          formatUnits(poolData.oneTicketOfToken, poolData.lockTokenDecimals)
      ) + ` $${poolData.lockTokenSymbol}`
    );
  };

  const approve = (token, balance) => {
    setBtnLoadingMsg("Waiting approve...");
    setPageLoadingMsg(`Please confirm the ${connectedWalletInfo} request`);
    setPageLoading(true);
    const result = token.contract
      .approve(process.env.REACT_APP_CONTRACT_ADDRESS, balance)
      .then(async (result) => {
        const receipt = await result.wait();
        setResultMsg({
          msgType: 2,
          urlTitle: "view TX",
          url: `${process.env.REACT_APP_NETWORKSCAN}tx/${receipt.hash}`,
          msg: `Approval`,
        });
        console.log("receipt (Approve):", receipt);
        setBtnLoadingMsg(null);
        setBtnLoading(null);
        setPageLoadingMsg(null);
        setPageLoading(false);
        return true;
      })
      .catch((error) => {
        setResultMsg({
          msgType: 1,
          msg: `(Approve) ${error.reason || error.message}`,
        });
        console.log("error (Approve):", error);
        setBtnLoadingMsg(null);
        setBtnLoading(null);
        setPageLoadingMsg(null);
        setPageLoading(false);
        return false;
      });
    return result;
  };

  const joinPool = async (joinValues) => {
    setBtnLoadingMsg("Waiting...");
    setBtnLoading(joinValues.buttonName);
    const joinTicketCount = Number(joinTicketCountRef.current.value);
    let refCode = encodeBytes32String("null");
    // if (usedRefCodeRef.current.value !== "") {
    //   refCode = encodeBytes32String(usedRefCodeRef.current.value);
    // }

    if (joinTicketCount < 1) {
      setBtnLoading(null);
      setBtnLoadingMsg(null);
      setResultMsg({ msgType: 1, msg: "Invalid ticket amount" });
      return;
    }
    if (
      Number(await unSignerVars.contract.getStatus(joinValues.poolId)) !== 2
    ) {
      setBtnLoading(null);
      setBtnLoadingMsg(null);
      setResultMsg({
        msgType: 1,
        msg: "The selected pool status must be join",
      });
      return;
    }
    if (decodeBytes32String(refCode) !== "null") {
      const isRefCode = await unSignerVars.contract.isRefCode(refCode);
      if (!isRefCode) {
        setBtnLoading(null);
        setBtnLoadingMsg(null);
        setResultMsg({ msgType: 1, msg: "Invalid reference code" });
        return;
      }
    }
    if (
      contractGetInfo !== null &&
      contractGetInfo.assignTicketCount >= joinValues.maxTicketCount
    ) {
      setBtnLoading(null);
      setBtnLoadingMsg(null);
      setResultMsg({ msgType: 1, msg: "Pool limit is reached" });
      return;
    }
    if (
      contractGetInfo !== null &&
      contractGetInfo.assignTicketCount + joinTicketCount >
        joinValues.maxTicketCount
    ) {
      setBtnLoading(null);
      setBtnLoadingMsg(null);
      setResultMsg({
        msgType: 1,
        msg: "Ticket count is more than pool max tickets count",
      });
      return;
    }
    if (
      contractGetInfo !== null &&
      contractGetInfo.userTicketCount + joinTicketCount >
        joinValues.poolTicketLimit
    ) {
      const availableUserTicket =
        joinValues.poolTicketLimit - contractGetInfo.userTicketCount;
      if (availableUserTicket >= joinValues.minTicketCount) {
        setResultMsg({
          msgType: 1,
          msg: `${joinTicketCount} maximum amount limit exceeded. Amount available is ${availableUserTicket}`,
        });
      } else {
        setResultMsg({
          msgType: 1,
          msg: "maximum amount limit exceeded",
        });
      }
      setBtnLoading(null);
      setBtnLoadingMsg(null);
      return;
    }

    const lockToken = await getToken(
      signerVars,
      unSignerVars,
      joinValues.lockTokenAddress,
      address
    ).catch((error) => {
      setResultMsg({
        msgType: 1,
        msg: `(lockToken) ${error.reason || error.message}`,
      });
    });

    if (
      joinTicketCount * Number(joinValues.oneTicketOfToken) >
      Number(lockToken.balance)
    ) {
      setBtnLoading(null);
      setResultMsg({
        msgType: 1,
        msg: `Not enough ${joinValues.lockTokenSymbol} token liquidity at your wallet`,
      });
      return;
    }

    if (
      Number(lockToken.allowanceAmount) <
      joinTicketCount * Number(joinValues.oneTicketOfToken)
    ) {
      const approveResult = await approve(lockToken, lockToken.balance);
      if (!approveResult) return;
    }

    setBtnLoadingMsg("Waiting Join...");
    setBtnLoading(joinValues.buttonName);
    setPageLoadingMsg(`Please confirm the ${connectedWalletInfo} request`);
    setPageLoading(true);
    const estimateGas = Number(
      await signerVars.contract.joinPool.estimateGas(
        joinValues.poolId,
        joinTicketCount,
        refCode
      )
    );
    console.log("estimateGas:", estimateGas);
    signerVars.contract
      .joinPool(joinValues.poolId, joinTicketCount, refCode, {
        gasLimit: estimateGas,
      })
      .then(async (result) => {
        const receipt = await result.wait();
        for (let i = 0; i < receipt.logs.length; i++) {
          if (receipt.logs[i].eventName === "UserJoined") {
            console.log(receipt.logs[i]);
            setResultMsg({
              msgType: 2,
              urlTitle: "View TX",
              url: `${process.env.REACT_APP_NETWORKSCAN}tx/${receipt.hash}`,
              msg: `${receipt.logs[i].args[2]} bought tickets for ${Number(
                formatUnits(receipt.logs[i].args[3], poolData.lockTokenDecimals)
              ).toFixed(2)} ${joinValues.lockTokenSymbol} tokens.`,
            });
            setBtnLoadingMsg(null);
            setBtnLoading(null);
            setPageLoadingMsg(null);
            setPageLoading(false);
            setReRender((prevState) => !prevState);

            dispatch(
              getInfo({
                dispatch,
                unSignerVars,
                poolId: poolData.poolId,
                address,
              })
            )
              .then((result) => {
                if (result.payload.result) {
                  setContractGetInfo(result.payload.result);
                }
              })
              .catch((error) => console.error(error));
            getTotalLockAmount();
          }
        }
        console.log("receipt (UserJoined):", receipt);
      })
      .catch((error) => {
        setResultMsg({
          msgType: 1,
          msg: error.reason || error.message,
        });
        console.log("error (UserJoined):", error);
        setBtnLoadingMsg(null);
        setBtnLoading(null);
        setPageLoadingMsg(null);
        setPageLoading(false);
      });
  };

  const claimTokens = async (claimValues) => {
    setBtnLoadingMsg("Waiting Claim...");
    setBtnLoading(claimValues.buttonName);
    if (claimValues.status !== 5 && claimValues.status !== 7) {
      setBtnLoadingMsg(null);
      setBtnLoading(null);
      setResultMsg({
        msgType: 1,
        msg: "The selected pool status must be claim or refund",
      });
      return;
    }
    if (
      Number(
        await unSignerVars.contract.totalLockAmount(claimValues.poolId, address)
      ) < 1
    ) {
      setBtnLoadingMsg(null);
      setBtnLoading(null);
      setResultMsg({
        msgType: 1,
        msg: `No lock tokens`,
      });
      return;
    }
    if (
      Boolean(
        await unSignerVars.contract.isClaimed(claimValues.poolId, address)
      )
    ) {
      setBtnLoadingMsg(null);
      setBtnLoading(null);
      setResultMsg({
        msgType: 1,
        msg: `Already claimed`,
      });
      return;
    }

    const prizeToken = await getToken(
      signerVars,
      unSignerVars,
      claimValues.prizeTokenAddress,
      process.env.REACT_APP_CONTRACT_ADDRESS
    ).catch((error) => {
      setResultMsg({
        msgType: 1,
        msg: `(lockToken) ${error.reason || error.message}`,
      });
    });

    console.log(
      Number(totalPrize),
      Number(formatUnits(prizeToken.balance, poolData.prizeTokenDecimals))
    );
    if (
      Number(totalPrize) >
      Number(formatUnits(prizeToken.balance, poolData.prizeTokenDecimals))
    ) {
      setBtnLoadingMsg(null);
      setBtnLoading(null);
      setResultMsg({
        msgType: 1,
        msg: `Not enough ${claimValues.prizeTokenSymbol} token liquidity at contract`,
      });
      return;
    }

    setPageLoadingMsg(`Please confirm the ${connectedWalletInfo} request`);
    setPageLoading(true);
    const estimateGas = Number(
      await signerVars.contract.claimTokens.estimateGas(claimValues.poolId)
    );
    console.log("estimateGas:", estimateGas);
    signerVars.contract
      .claimTokens(claimValues.poolId, { gasLimit: estimateGas })
      .then(async (result) => {
        const receipt = await result.wait();
        for (let i = 0; i < receipt.logs.length; i++) {
          if (receipt.logs[i].eventName === "PrizeClaimed") {
            setResultMsg({
              msgType: 2,
              urlTitle: "view TX",
              url: `${process.env.REACT_APP_NETWORKSCAN}tx/${receipt.hash}`,
              msg: `You claimed ${Number(
                formatUnits(receipt.logs[i].args[2], poolData.lockTokenDecimals)
              ).toFixed(2)} ${claimValues.lockTokenSymbol} tokens and ${Number(
                formatUnits(
                  receipt.logs[i].args[3],
                  poolData.prizeTokenDecimals
                )
              ).toFixed(2)} ${claimValues.prizeTokenSymbol} tokens`,
            });
            setBtnLoadingMsg(null);
            setBtnLoading(null);
            setPageLoadingMsg(null);
            setPageLoading(false);
            setIsClaimed(true);
          }
        }
        console.log("receipt (PrizeClaimed):", receipt);
      })
      .catch((error) => {
        setResultMsg({
          msgType: 1,
          msg: `(PrizeClaimed) ${error.reason || error.message}`,
        });
        console.log("error (PrizeClaimed):", error);
        setBtnLoadingMsg(null);
        setBtnLoading(null);
        setPageLoadingMsg(null);
        setPageLoading(false);
      });
  };

  const getUserTokenBalance = async () => {
    const lockToken = await getToken(
      signerVars,
      unSignerVars,
      poolData.lockTokenAddress,
      address
    ).catch((error) => {
      setResultMsg({
        msgType: 1,
        msg: `(lockToken) ${error.reason || error.message}`,
      });
    });
    if (lockToken) {
      setUserBalance(
        formatUnits(lockToken.balance, poolData.lockTokenDecimals)
      );
    }
  };

  useEffect(() => {
    // yüzdelik locked token hesabı
    let amount = Math.round(
      ((Number(contractGetInfo.maxTicketCount - contractGetInfo.ticketCount) *
        formatUnits(poolData.oneTicketOfToken, poolData.lockTokenDecimals)) /
        Number(formatUnits(poolData.totalPool, poolData.lockTokenDecimals))) *
        100
    );
    setLockedAmount(amount);
  }, [contractGetInfo]);

  useEffect(() => {
    if (
      isConnected &&
      address &&
      unSignerVars.contract &&
      poolData &&
      poolData.poolId > 0
    ) {
      if (poolData.status === 5 || poolData.status === 7) {
        dispatch(
          getIsClaimed({
            dispatch,
            unSignerVars,
            poolId: poolData.poolId,
            address,
          })
        )
          .then((result) => {
            if (result.payload) {
              setIsClaimed(result.payload.result);
            }
          })
          .catch((error) => console.error(error));
      }

      getUserTokenBalance();
      getTotalLockAmount();

      dispatch(
        getInfo({ dispatch, unSignerVars, poolId: poolData.poolId, address })
      )
        .then((result) => {
          if (result.payload.result) {
            setContractGetInfo(result.payload.result);
            getTotalPrizeAmount();
          }
        })
        .catch((error) => console.error(error));
    }
  }, [isConnected, poolData, unSignerVars]);

  return (
    <>
      {pageLoading && <PageLoading pageLoadingMsg={pageLoadingMsg} />}

      {togglePrizeDetails && (
        <PrizeDetails onClose={() => setTogglePrizeDetails(false)} />
      )}

      {toggleUserTickets && (
        <UserTicketsPopup onClose={() => setToggleUserTickets(false)} />
      )}

      <div className="container-box">
        <div
          onClick={() => handleFlyToCity(initialData)}
          className="close-button"
        >
          <img src={Close} alt="" />
        </div>
        <div className="stakeheader">
          <div className={"info"}>
            <div className="text fw-bold" title={poolData.name}>
              <img src={Pin} alt="" /> {poolData.name}
            </div>
          </div>
          <div className="divider"></div>
          <div className={"info"}>
            {poolData.status === 2 ? (
              <>
                Time Left to Join
                <div className="text">
                  <Countdown
                    status={poolData.status}
                    startTime={poolData.createDate}
                    endTime={poolData.createDate + poolData.joinDay}
                  />
                </div>
              </>
            ) : poolData.status > 2 ? (
              <>
                Time Left to Lock
                <div className="text">
                  <Countdown
                    status={poolData.status}
                    startTime={poolData.createDate}
                    endTime={
                      poolData.createDate + poolData.joinDay + poolData.lockDay
                    }
                  />
                </div>
              </>
            ) : (
              <>
                Countdown
                <div className="text">Not Started</div>
              </>
            )}
          </div>
          <div className="divider"></div>
          <div className={"info"}>
            Pool Status
            <div className="text">{statusText(poolData.status)}</div>
          </div>
        </div>
        <div className="city-images">
          {poolImages
            .keys()
            .map(
              (image, index) =>
                poolData.name
                  .toLowerCase()
                  .search(image.substr(2).split(".")[0].toLowerCase()) > -1 && (
                  <img
                    key={index}
                    src={poolImages(image)}
                    alt={`pool-${poolData.name.toLowerCase()}`}
                  />
                )
            )}
        </div>
        <div className="pool-info">
          <div className="d-flex justify-content-between align-items-center w-100 info-item">
            <div>CITY POOL:</div>
            <div className="placeholder-glow" style={{ margin: 0 }}>
              <span className={!poolData ? "placeholder col-12" : ""}>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    window.open(
                      `${process.env.REACT_APP_NETWORKSCAN}address/${poolData.lockTokenAddress}`
                    )
                  }
                >
                  {formatUnits(poolData.totalPool, poolData.lockTokenDecimals)}
                  {" $"}
                  {poolData.lockTokenSymbol}
                </div>
              </span>
              {/* <p
                className={!poolData ? "placeholder col-12" : ""}
                style={{ textAlign: "end", margin: 0 }}
              >
                ({poolData.maxTicketCount} Ticket)
              </p> */}
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center w-100 info-item">
            <div>LOCK PERIOD:</div>
            <div className="placeholder-glow">
              {formatSecondToDay(poolData.lockDay)}
            </div>
          </div>
          <div className="d-flex justify-content-between w-100 info-item">
            <div>TOTAL LOCKED:</div>
            <div
              className={!poolData ? "placeholder col-12" : ""}
              style={{ textAlign: "end", margin: 0 }}
            >
              <div
                style={{ cursor: "pointer" }}
                onClick={() =>
                  window.open(
                    `${process.env.REACT_APP_NETWORKSCAN}address/${poolData.prizeTokenAddress}`
                  )
                }
              >
                {(contractGetInfo.maxTicketCount -
                  contractGetInfo.ticketCount) *
                  formatUnits(
                    poolData.oneTicketOfToken,
                    poolData.lockTokenDecimals
                  )}
                {" $"}
                {poolData.lockTokenSymbol}
              </div>
            </div>
          </div>
          <div className="info-item w-100">
            <div className="progress-container">
              <div
                style={{
                  width: `${lockedAmount}%`,
                }}
                className="progress-bar"
              ></div>
              <div className="text">{`${lockedAmount}%`}</div>
            </div>
          </div>
          <div className="d-flex justify-content-between w-100 info-item">
            <div>
              TOTAL PRIZE:
              <span className="detail">
                <Link to={search} onClick={() => setTogglePrizeDetails(true)}>
                  *View Prize Details
                </Link>
              </span>
            </div>
            <div
              className={!poolData ? "placeholder col-12" : ""}
              style={{ textAlign: "end", margin: 0 }}
            >
              <div
                style={{ cursor: "pointer" }}
                onClick={() =>
                  window.open(
                    `${process.env.REACT_APP_NETWORKSCAN}address/${poolData.prizeTokenAddress}`
                  )
                }
              >
                {formatUnits(
                  poolData.totalPrizeToken,
                  poolData.prizeTokenDecimals
                )}{" "}
                {poolData.prizeTokenSymbol}
              </div>
            </div>
          </div>
        </div>
        <div className={"minamount"}>
          *1 ticket costs{" "}
          {formatUnits(poolData.oneTicketOfToken, poolData.lockTokenDecimals)} $
          {poolData.lockTokenSymbol}
        </div>
        <div className={"minamount"}>
          *The minimum lock amount is {poolData.minTicketCount} ticket and you
          can buy max {poolData.callbackMaxTicket} tickets at once. Repeat the
          process for more.
        </div>
        {isConnected && (
          <div className={"minamount fw-bold"}>
            *Your {poolData.lockTokenSymbol} Balance:{" "}
            <span
              className={userBalance === null ? "placeholder col-12" : ""}
              style={{ fontWeight: "bold", display: "inline" }}
            >
              {Number(userBalance).toFixed(2)}
            </span>
          </div>
        )}

        <div className="container-box-bottom">
          {!isConnected ? (
            <div className="d-grid col-12 connect-button-field justify-content-center">
              <ConnectButton />
            </div>
          ) : (
            <>
              {/* Deactive Screen */}
              {poolData.status === 1 && (
                <>
                  <div className={"ready-msg"}>
                    <div className="text-center fw-bold">Opening Soon</div>
                  </div>
                </>
              )}
              {/* Join Screen */}
              {poolData.status === 2 && (
                <>
                  <div className="token-amount">
                    <div className="input-area">
                      <input
                        ref={joinTicketCountRef}
                        onChange={(e) => changeTicketCount(poolData)}
                        type="number"
                        min={1}
                        max={poolData.callbackMaxTicket}
                        placeholder="Ticket Amount"
                      />
                    </div>
                    <div className="amountText">
                      <img className="w-100" src={ArrowDown} alt="" />
                    </div>
                    <div className="input-area">
                      <input
                        disabled
                        type="text"
                        placeholder="Token Amount"
                        value={tokenAmount}
                      />
                    </div>
                  </div>
                  {/* <div className="token-amount">
                      <input
                        ref={usedRefCodeRef}
                        placeholder="Ref Code (optional)"
                        style={{ display: "inline-block" }}
                      />
                    </div> */}
                  <div className="btns-area">
                    <button
                      className={
                        btnLoading && btnLoading === "Join Pool"
                          ? "stake-button btn-disabled"
                          : "stake-button"
                      }
                      onClick={() =>
                        joinPool({
                          buttonName: "Join Pool",
                          poolId: poolData.poolId,
                          minTicketCount: poolData.minTicketCount,
                          maxTicketCount: poolData.maxTicketCount,
                          lockTokenAddress: poolData.lockTokenAddress,
                          lockTokenSymbol: poolData.lockTokenSymbol,
                          status: poolData.status,
                          oneTicketOfToken: poolData.oneTicketOfToken,
                          createDate: poolData.createDate,
                          joinDay: poolData.joinDay,
                          poolTicketLimit: poolData.poolTicketLimit,
                        })
                      }
                    >
                      {btnLoading && btnLoading === "Join Pool" ? (
                        <>
                          <span className="spinner-border spinner-border-sm"></span>
                          {` ${btnLoadingMsg}`}
                        </>
                      ) : (
                        "Join & Lock"
                      )}
                    </button>
                  </div>
                </>
              )}
              {/* Lock & Raffle Screen */}
              {(poolData.status === 3 || poolData.status === 4) && (
                <>
                  {contractGetInfo.userTicketCount !== null &&
                  contractGetInfo.userTicketCount < 1 ? (
                    <div className={"ready-msg"}>
                      <div className="text-center fw-bold">Not Joined</div>
                    </div>
                  ) : Math.floor(Date.now() / 1000) >
                      poolData.createDate +
                        poolData.joinDay +
                        poolData.lockDay && poolData.status < 5 ? (
                    <>
                      {poolData.status === 4 ? (
                        <div className="d-flex align-items-center justify-content-between w-100 gap5">
                          <div className="success-msg d-flex align-items-center justify-content-between w-100">
                            <div className="fw-bold">PRIZE WON:</div>
                            <div className="fw-bold">
                              {Number(totalPrize).toFixed(2)} $
                              {poolData.prizeTokenSymbol}
                            </div>
                          </div>
                          <div className="unlock-msg d-flex align-items-center justify-content-center flex-column">
                            <div>TOKEN UNLOCK</div>
                            <div>
                              {Number(totalLock).toFixed(2)} $
                              {poolData.lockTokenSymbol}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="success-msg d-flex align-items-center justify-content-between">
                          <div className="fw-bold">PRIZE WON:</div>
                          <div className="fw-bold">RAFFLE AWAITED</div>
                        </div>
                      )}

                      <div className="btns-area">
                        <button
                          className={"stake-button btn-disabled w-100"}
                          disabled
                        >
                          {btnLoading && btnLoading === "Claim" ? (
                            <>
                              <span className="spinner-border spinner-border-sm"></span>
                              {` ${btnLoadingMsg}`}
                            </>
                          ) : (
                            "Waiting For Claim"
                          )}
                        </button>
                      </div>
                    </>
                  ) : (
                    <div className="success-msg d-flex align-items-center justify-content-between">
                      <div className="fw-bold">PRIZE WON:</div>
                      <div className="fw-bold">RAFFLE AWAITED</div>
                    </div>
                  )}
                </>
              )}
              {/* Claim & Refund Screen */}
              {(poolData.status === 5 || poolData.status === 7) && (
                <>
                  {contractGetInfo.userTicketCount !== null &&
                  contractGetInfo.userTicketCount < 1 ? (
                    <div className={"ready-msg"}>
                      <div className="text-center fw-bold">Not Joined</div>
                    </div>
                  ) : (
                    <>
                      {poolData.status !== 7 ? (
                        //Claim status
                        <div className="d-flex align-items-center justify-content-between w-100 gap5">
                          <div className="success-msg d-flex align-items-center justify-content-between w-100">
                            <div className="fw-bold">PRIZE WON:</div>
                            <div className="fw-bold">
                              {Number(totalPrize).toFixed(2)} $
                              {poolData.prizeTokenSymbol}
                            </div>
                          </div>
                          <div className="unlock-msg d-flex align-items-center justify-content-center flex-column">
                            <div>TOKEN UNLOCK</div>
                            <div>
                              {Number(totalLock).toFixed(2)} $
                              {poolData.lockTokenSymbol}
                            </div>
                          </div>
                        </div>
                      ) : (
                        //Refund status
                        <>
                          <div className={"ready-msg"}>
                            <div className="text-center">
                              Sorry, due to an issue, we had to cancel this
                              pool.
                            </div>
                          </div>
                          <div className="success-msg d-flex align-items-center justify-content-between">
                            <div className="fw-bold">REFUND:</div>
                            <div className="fw-bold">
                              {Number(totalLock).toFixed(2)} $
                              {poolData.lockTokenSymbol}
                            </div>
                          </div>
                        </>
                      )}

                      <div className="btns-area">
                        <button
                          className={
                            btnLoading && btnLoading === "Claim"
                              ? "stake-button btn-disabled w-100"
                              : isClaimed
                              ? "stake-button btn-disabled w-100"
                              : "stake-button w-100"
                          }
                          disabled={isClaimed ? true : false}
                          onClick={() =>
                            claimTokens({
                              buttonName: "Claim",
                              poolId: poolData.poolId,
                              status: poolData.status,
                              lockTokenAddress: poolData.lockTokenAddress,
                              lockTokenSymbol: poolData.lockTokenSymbol,
                              prizeTokenAddress: poolData.prizeTokenAddress,
                              prizeTokenSymbol: poolData.prizeTokenSymbol,
                            })
                          }
                        >
                          {btnLoading && btnLoading === "Claim" ? (
                            <>
                              <span className="spinner-border spinner-border-sm"></span>
                              {` ${btnLoadingMsg}`}
                            </>
                          ) : isClaimed ? (
                            "Claimed"
                          ) : (
                            "Claim"
                          )}
                        </button>
                      </div>
                    </>
                  )}
                </>
              )}
              {/* Ended Screen */}
              {poolData.status === 6 && (
                <>
                  {contractGetInfo.userTicketCount !== null &&
                  contractGetInfo.userTicketCount < 1 ? (
                    <div className={"ready-msg"}>
                      <div className="text-center fw-bold">Not Joined</div>
                    </div>
                  ) : (
                    <div className={"error-msg"}>
                      <div className="text-center fw-bold">Ended</div>
                    </div>
                  )}
                </>
              )}

              <div className="footer">
                <div className="d-flex justify-content-between align-items-center">
                  <div>My Tickets:</div>
                  <div>
                    <span
                      className={
                        contractGetInfo.userTicketCount === null
                          ? "placeholder col-12"
                          : ""
                      }
                    >
                      {Number(contractGetInfo.userTicketCount)}{" "}
                    </span>
                    <Link
                      className="viewAnim"
                      to={search}
                      onClick={() => {
                        if (
                          contractGetInfo.userTicketCount !== null &&
                          contractGetInfo.userTicketCount > 0
                        ) {
                          setToggleUserTickets(true);
                        } else {
                          setResultMsg({
                            msgType: 1,
                            msg: `You have not joined this pool yet`,
                          });
                        }
                      }}
                    >
                      (View Tickets)
                    </Link>
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <div>My Locked Tokens:</div>
                  <div>
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        window.open(
                          `${process.env.REACT_APP_NETWORKSCAN}address/${poolData.lockTokenAddress}`
                        )
                      }
                    >
                      <div
                        className={
                          totalLock === null ? "placeholder col-12" : ""
                        }
                      >
                        {Number(totalLock).toFixed(2)}
                        {" $"}
                        {poolData.lockTokenSymbol}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {resultMsg.msgType > 0 && (
                <div
                  className={
                    resultMsg.msgType === 1 ? "error-msg" : "success-msg"
                  }
                >
                  <div className="text-center fw-bold">
                    {resultMsg.msgType === 1 ? `ERROR!` : `SUCCESSFUL!`}
                  </div>
                  <>
                    {resultMsg.msg}{" "}
                    {resultMsg.url && (
                      <Link
                        to={resultMsg.url}
                        target="_blank"
                        className="padding-0-1"
                      >
                        {`(${resultMsg.urlTitle})`}
                      </Link>
                    )}
                  </>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Stake;
